import React from "react";
import { Link } from "react-router-dom";
import { FaExclamationTriangle, FaHome } from "react-icons/fa";
import "../styles/NotFound.css";

export default function NotFound() {
  return (
    <section className="not-found-section">
      <div className="not-found-container">
        <FaExclamationTriangle className="not-found-icon" />

        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>

        <p className="not-found-description">
          Oops! The page you're looking for doesn't exist. It might have been
          moved, deleted, or you entered the wrong URL.
        </p>

        <div className="not-found-actions">
          <Link to="/" className="btn btn-primary">
            <FaHome />
            Go Home
          </Link>
        </div>
      </div>
    </section>
  );
}
